import { FC } from "react"
import { Box, SxProps, Typography } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"

interface InfoBannerProps {
  description: string | JSX.Element
  title?: string | JSX.Element
  sx?: SxProps
}

export const InfoBanner: FC<InfoBannerProps> = ({ description, title, sx }) => {
  return (
    <Box sx={{
      display: 'flex',
      gap: '8px',
      borderLeft: '5px solid #17374F',
      backgroundColor: '#CAE5EF',
      pl: '8px',
      py: '24px',
      pr: '16px',
      ...sx
    }}>
      <InfoOutlined sx={{ fontSize: '30px' }} color="primary"/>
      <Box>
        {title && <Typography variant="body1" sx={{ 
          color: 'primary.main', 
          fontSize: '16px', 
          lineHeight: '25px', 
          mb: '28px', 
          fontWeight: 700,
          wordBreak: 'break-word'
        }}>
          {title}
        </Typography>}
        <Typography variant="body1" sx={{ fontSize: '14px', lineHeight: '20px' }}>
          {description}
        </Typography>
      </Box>
    </Box>
  )
}